import { IBuilder, IOffer } from '../../types/offer';

export function getBuilderFromOffer(offer: IOffer): IBuilder | null {
  const { builder } = offer;

  return builder || null;
}
